import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';
import {
  HeaderCloseButton,
  HeaderLeftAction,
  HeaderTitle,
  HeaderTitleWrapper
} from '../../../ui/PageHeader/styled';
import { tagStyles } from '../../../ui/Typography/styles';
import { FlexColumn, FlexibleDiv } from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';

export const modalStyles = css`
  border-radius: 7px 7px 0 0;
  padding-bottom: env(safe-area-inset-bottom);
  height: calc(100% - 60px);
  align-self: end;

  @media (min-width: ${Breakpoints.tablet}px) {
    align-self: end;
    height: calc(100% - 60px);
    width: 100%;
    max-width: 100%;
    max-height: calc(100% - 60px);
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    align-self: center;
    height: 640px;
    width: 1000px;
    max-width: calc(100% - 80px);
    padding-bottom: 20px;
  }
`;

export const headerStyles = css`
  ${HeaderLeftAction} {
    width: 45px;
    ${HeaderCloseButton} {
      padding: 0;
    }
  }

  @media (min-width: ${Breakpoints.tablet}px) {
    padding-left: 40px;

    ${HeaderTitleWrapper} {
      text-align: center;
    }

    ${HeaderTitle} {
      ${tagStyles.h3};
    }
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    height: 72px;
    padding-left: 30px;

    ${HeaderTitle} {
      ${tagStyles.h2};
    }

    ${HeaderTitleWrapper} {
      text-align: left;
    }

    ${HeaderLeftAction} {
      height: 45px;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
`;

export const ModalContent = styled(FlexColumn)`
  gap: 20px;
  height: 100%;
  overflow-y: scroll;
  padding: 20px 15px 40px;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 20px 40px 40px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 20px 30px 30px;
  }
`;

export const ParamsModalItemsTitle = styled(Typography)`
  display: block;
  margin-bottom: 20px;
`;

export const ParamsBlock = styled.div`
  padding-bottom: 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
`;

export const ParamsContent = styled(FlexColumn)`
  gap: 10px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: block;
    column-count: 2;
    column-width: 350px;
    column-gap: 70px;
    width: max-content;
  }
`;

export const ParamsItem = styled(FlexibleDiv)`
  gap: 10px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    width: 350px;

    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
`;

export const ParamsItemValue = styled(Typography)`
  flex: 1;
`;

export const ParamsItemTitle = styled(ParamsItemValue)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const FacilitiesContent = styled(FlexColumn)`
  gap: 15px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: block;
    column-count: 2;
    column-width: 350px;
    column-gap: 70px;
    width: max-content;
  }
`;

export const FacilitiesItem = styled(Typography)`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: block;
    width: 350px;

    &:not(:last-child) {
      margin-bottom: 15px;
    }
  }
`;
